// html 내용이 있는 샘플
// const JS_FILE_CONTENT = `function main() {
//   for (let i = 0; i < 3; i++) {
//     console.log('hello world', i);
//   }
// }

// console.log('test.js');
// main();

// document.body.style.backgroundColor = '#f2f3d2';
// document.querySelector('main').innerHTML = \`
// <pre>안녕하세요. 반갑습니다.
// 여기는 재미있게 HTML을 배우는 곳입니다.
// </pre>
// \`;
// `;

const JS_FILE_CONTENT = `for (let i = 0; i < 5; i++) {
  console.log('hello world', i);
}
`;

const HTML_FILE_CONTENT = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
  </head>
  <body>
    <main>
    </main>
    <script src="main.js"></script>
  </body>
</html>
`;

export const DEFAULT_FILES = [
  {
    name: 'main.js',
    language: 'javascript',
    code: JS_FILE_CONTENT,
  },
  {
    name: 'index.html',
    language: 'html',
    code: HTML_FILE_CONTENT,
  },
];
